import React from 'react'
import styles from './Contact.module.css'
import Form from './Form'

export default function Contact() {
    return (
        <div id="contact" className={styles.container}>
            <div className={styles.wrapper}>
                <h1 className="title">
                    <span className="underline">
                    Холбоо барих 
                    </span>
                </h1>
                <div className={styles.contents}>
                    <div className={styles.left}>
                        <div className={styles.left_wrapper}>
                            <ul>
                                <li>
                                    <div className={styles.icon}>
                                        <img src="./bx_bxs-phone.svg" alt="phone number" />
                                    </div>
                                    <p>+976 88113855</p>
                                </li>
                                <li>
                                    <div className={styles.icon}>
                                        <img src="./fluent_mail-20-filled.svg" alt="email"/>
                                    </div>
                                    danzanshadav@gmail.com
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className={styles.right}>
                        <Form/>
                    </div>
                </div>
            </div>
        </div>
    )
}
